import { createSlice } from '@reduxjs/toolkit';
import {
  CreateMajorCategory,
  DeleteMajorCategory,
  GetAllMajorCategory,
  GetAllMajorMajorCategory,
  GetSingleMajorCategoryDetails,
  SearchForMajorCategorysByName,
  UploadMajorCategoryIcon,
  UploadMajorCategoryImage,
} from './major_category_services_sync';

export const majorCategorySlice = createSlice({
  name: 'major_category',
  initialState: {
    major_category_loader: false,
    allMajorCategoryLoader: true,
    majorCategoryDeleteLoader: false,
    majorCategoryEditLoader: false,
    majorCatEditLoader: false,
    message: '',
    completeMajorCategory: {},
    completeMajorMajorCategory: [],
    majorCategoryDetails: {},
    majorCategoryImageDetails: {},
    majorCategoryIconDetails: {},
    completeMajorCategorySearch: {},
    major_category_page: 0,
    major_category_limit: 10,
    editMajorCategoryId: '',
  },
  reducers: {
    clearState: (state) => {
      state.major_category_loader = false;
      state.message = '';
      state.completeMajorCategory = {};
      state.completeMajorMajorCategory = [];
      state.allMajorCategoryLoader = true;
      state.majorCategoryDeleteLoader = false;
      state.majorCategoryEditLoader = false;
      state.majorCatEditLoader = false;
      state.majorCategoryDetails = {};
      state.completeMajorCategorySearch = {};
      state.majorCategoryImageDetails = {};
      state.majorCategoryIconDetails = {};
      state.editMajorCategoryId = '';

      return state;
    },

    updateMajorCategoryDetails: (state, action) => {
      state.majorCategoryDetails = action.payload;
    },

    updateCompleteMajorCategory: (state, action) => {
      state.completeMajorCategory = action.payload;
    },
    updateMajorCategoryId: (state, { payload }) => {
      state.editMajorCategoryId = payload;
    },

    updateMajorCategoryImageDetails: (state, { payload }) => {
      state.majorCategoryImageDetails = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(CreateMajorCategory.pending, (state) => {
        state.major_category_loader = true;
      })
      .addCase(CreateMajorCategory.fulfilled, (state, { payload }) => {
        // let addCategory = {...payload?.data, six ...state?.completeMajorCategory};

        // state.completeMajorCategory = addCategory;

        state.major_category_loader = false;
        state.message = payload.message;
        state.majorCategoryImageDetails = {};
      })
      .addCase(CreateMajorCategory.rejected, (state, { payload }) => {
        state.major_category_loader = false;
        state.message = payload.message;
      })
      .addCase(UploadMajorCategoryImage.pending, (state) => {
        state.majorCategoryEditLoader = true;
      })
      .addCase(UploadMajorCategoryImage.fulfilled, (state, { payload }) => {
        state.majorCategoryEditLoader = false;
        state.profileMessage = payload.message;
        state.majorCategoryImageDetails = payload.data;
      })
      .addCase(UploadMajorCategoryImage.rejected, (state, { payload }) => {
        state.majorCategoryEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(UploadMajorCategoryIcon.pending, (state) => {
        state.majorCategoryEditLoader = true;
      })
      .addCase(UploadMajorCategoryIcon.fulfilled, (state, { payload }) => {
        state.majorCategoryEditLoader = false;
        state.profileMessage = payload.message;
        state.majorCategoryIconDetails = payload.data;
      })
      .addCase(UploadMajorCategoryIcon.rejected, (state, { payload }) => {
        state.majorCategoryEditLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(GetAllMajorCategory.pending, (state) => {
        state.major_category_loader = true;
      })
      .addCase(GetAllMajorCategory.fulfilled, (state, { payload }) => {
        state.major_category_loader = false;
        state.message = payload.message;
        state.completeMajorCategory = payload.data;
        state.major_category_page = payload?.data?.page;
      })
      .addCase(GetAllMajorCategory.rejected, (state, { payload }) => {
        state.major_category_loader = false;
        state.message = payload.message;
      })
      .addCase(GetAllMajorMajorCategory.pending, (state) => {
        state.major_category_loader = true;
      })
      .addCase(GetAllMajorMajorCategory.fulfilled, (state, { payload }) => {
        state.major_category_loader = false;
        state.message = payload.message;
        state.completeMajorMajorCategory = payload.data;
      })
      .addCase(GetAllMajorMajorCategory.rejected, (state, { payload }) => {
        state.major_category_loader = false;
        state.message = payload.message;
      })
      .addCase(DeleteMajorCategory.pending, (state) => {
        state.majorCategoryDeleteLoader = true;
      })
      .addCase(DeleteMajorCategory.fulfilled, (state, { payload }) => {
        const filterData = state.completeMajorCategory?.docs?.filter(
          (item) => item._id !== payload?.data?._id
        );

        state.completeMajorCategory = {
          ...state.completeMajorCategory,
          docs: filterData,
        };

        state.majorCategoryDeleteLoader = false;
        state.message = payload.message;

        state.editMajorCategoryId = '';
      })
      .addCase(DeleteMajorCategory.rejected, (state, { payload }) => {
        state.majorCategoryDeleteLoader = false;
        state.message = payload.message;
        state.editMajorCategoryId = '';
      })
      .addCase(GetSingleMajorCategoryDetails.pending, (state) => {
        state.major_category_loader = true;
      })
      .addCase(
        GetSingleMajorCategoryDetails.fulfilled,
        (state, { payload }) => {
          state.major_category_loader = false;
          state.message = payload.message;
          state.majorCategoryDetails = payload.data;
        }
      )
      .addCase(GetSingleMajorCategoryDetails.rejected, (state, { payload }) => {
        state.major_category_loader = false;
        state.message = payload.message;
      })
      .addCase(SearchForMajorCategorysByName.pending, (state) => {
        state.major_category_loader = true;
      })
      .addCase(
        SearchForMajorCategorysByName.fulfilled,
        (state, { payload }) => {
          state.major_category_loader = false;
          state.message = payload?.message;

          state.completeMajorCategorySearch = payload?.data;
        }
      )
      .addCase(SearchForMajorCategorysByName.rejected, (state, { payload }) => {
        state.major_category_loader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  updateMajorCategoryDetails,
  updateCompleteMajorCategory,
  updateMajorCategoryId,
  updateMajorCategoryImageDetails,
} = majorCategorySlice.actions;
export const majorCategroySelector = (state) => state.major_category;

export default majorCategorySlice.reducer;
